var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tabs',{attrs:{"content-class":"","nav-class":"ml-1"}},[_c('b-tab',{attrs:{"no-body":"","title":_vm.$t('views.excmmessages.list.messagesApproved')}},[_c('MessagesApprovedList')],1),_c('b-tab',{attrs:{"no-body":"","title":_vm.$t('views.excmmessages.list.messagesToApprove')}},[_c('MessagesToApproveList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }